import { useContext } from 'react'

import { DashboardContext } from 'live/context/dashboard'
import { WidgetEditorContext } from 'live/context/widget-editor'

import { ASSET_LOOKUP } from '../constants'

export function useSelectedAssetLookup(): string {
    const dashboardContext = useContext(DashboardContext)
    const widgetEditorContext = useContext(WidgetEditorContext)

    const isEditor = Object.keys(widgetEditorContext).length > 0

    let selectedAsset = isEditor
        ? widgetEditorContext.filters?.applied?.lookupValues?.[ASSET_LOOKUP]
        : dashboardContext.state?.filterValues?.[ASSET_LOOKUP]
    if (Array.isArray(selectedAsset) && selectedAsset.length > 0) {
        selectedAsset = selectedAsset[0]
    }

    return selectedAsset
}
